<img
  class="check-image"
  aria-label="Image of the check showing location of the routing number, account number, and check number"
  [src]="isBusiness ? '/assets/images/business.png' : '/assets/images/personal.png'"
/>
